export default "__VITE_ASSET__BeUsSc5G__"